import { link } from 'fs'


//NOVAS ROTAS REFATORADAS --> VAMOS COLOCAR AQUI PARA DELETAR MAIS FACILMENTE AS INCORRETAS
const Login = () => import('../components/public/Login.vue')
const ResetPassword = () => import('../components/public/ResetPassword.vue')
const ForgotPassword = () => import('../components/public/ForgotPassword.vue')
const RegisterUser = () => import('../components/public/RegisterUser.vue')
const NewEmail = () => import('../components/public/NewEmail.vue')
const UserTemplate = () => import('../components/user/Template.vue')
const NewPasswordUser = () => import("../components/public/NewPasswordUser.vue")
const TermsAndConditions = () => import("../components/public/legal/terms_and_conditions.vue")
const PrivacyPolicy = () => import("../components/public/legal/privacy_policy.vue")
const NewCheck = () => import('../components/shared/NewVehicleRequestCheck.vue')
const Bluetooth = () => import('../components/shared/Bluetooth.vue')
const newVR = () => import('../components/shared/NewVehicleRequest.vue')
const ReservationInformation = () => import('../components/shared/ReservationInformation.vue')
const Help = () => import('../components/shared/Help.vue')
const PublicHelp = () => import('../components/public/PublicHelp.vue')
const NewDashboard = () => import('../components/user/NewDashboard.vue')
const NewPayment = () => import('../components/user/NewPayment.vue')
const NewProfile = () => import('../components/user/NewProfile.vue')
const Invite = () => import('../components/user/Invite.vue')
const CadastrationStatus = () => import('../components/public/RegistrationStatus.vue')
const CheckoutSummary = () => import('../components/user/CheckoutSummary.vue')
const Refuel = () => import('../components/user/Refuel.vue')
const FinishRefuel = () => import('../components/user/FinishRefuel.vue')

export const routes = [
  /* PUBLIC ROUTES */
  {
    path: '/',
    name: "baixe-app",
    component: Login,
  },
  {
    path: '/login',
    name: "login",
    component: Login,
  },
  {
    path: '/esqueci-minha-senha',
    name: 'forgotPassword',
    component: ForgotPassword
  },
  {
    path: '/cadastrar-usuario',
    name: 'registerUser',
    component: RegisterUser
  },
  {
    path: '/redefinir-senha/:email/:token',
    name: 'resetPassword',
    component: ResetPassword
  },
  {
    path: '/nova-senha/:email',
    name: 'newPasswordUser',
    component: NewPasswordUser
  },
  {
    path: '/alterar-email/:currentEmail/:newEmail/:token',
    name: 'changePassword',
    component: NewEmail
  },
  {
    path: "/legal/terms-and-conditions",
    name: "termsAndConditions",
    component: TermsAndConditions
  },
  {
    path: "/legal/privacy-policy",
    name: "privacyPolicy",
    component: PrivacyPolicy
  },
  {
    path: "/publicHelp",
    name: "publicHelp",
    component: PublicHelp
  },
  {
    path: '/registerStatus',
    name: "registerstatus",
    component: CadastrationStatus,
  },
  /* USER ROUTES */
  {
    path: '',
    components: {
      template: UserTemplate
    },
    children: [
      {
        path: '/user/minhas-reservas', name: 'driver-vehicle-request-dashboard', components: { content: NewDashboard }, props: true
      },
      {
        path: '/user/reserva/:id', name: 'driver-vehicle-request-detail', components: { content: NewCheck }, props: true
      },
      {
        path: '/user/reserva/:id/bluetooth', name: 'driver-vehicle-request-bluetooth', components: { content: Bluetooth }, props: true
      },
      {
        path: '/user/checkout/summary/:id', name: 'vehicle-request-checkout-summary', components: { content: CheckoutSummary }, props: true
      },
      {
        path: '/user/solicitar-reserva', name: 'driver-vehicle-request', components: { content: newVR }
      },
      {
        path: '/user/informacao-reserva', name: 'reservation-information', components: { content: ReservationInformation }
      },
      {
        path: '/user/perfil', name: 'usr-profile', components: { content: NewProfile }
      },
      {
        path: '/user/pagamento', name: 'payment', components: { content: NewPayment }
      },
      {
        path: '/user/ajuda', name: 'help', components: { content: Help }
      },
      {
        path: '/user/newcheck/:id', name: 'newcheck', components: { content: NewCheck }, props: true
      },
      {
        path: '/user/convidar', name: 'invite', components: { content: Invite }, props: true
      },
      {
        path: '/user/reserva/abastecer/:vehicleRequestId', name: 'vehicle-request-refuel', components: { content: Refuel }, props: true
      },
      {
        path: '/user/reserva/finalizar-abastecimento', name: 'vehicle-request-finish-refuel', components: { content: FinishRefuel }, props: true
      },
    ]
  }

]
